import type { GroupingItem } from '@vedalib/editor/lib/elements'
import { useCallback } from 'react'
import React from 'react'

import PanelIconImage from 'components/Editor/FloatingPanel/PanelIconImage'
import type { IRenderItemProps } from 'components/uiKit/ArrayControl'
import { IconButton, TileButton } from 'components/uiKit/Button'
import { Tooltip } from 'components/uiKit/Dropdown'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import { useGroupingFormValueUpdateForm } from './GroupingFormValueContext'
import * as s from './GroupingFormValueItemAnswer.module.scss'

const GroupingFormValueItemAnswer: React.FC<IRenderItemProps<GroupingItem>> = ({
  name,
  index,
  item,
  min,
  value: array,
  onChange,
}) => {
  const disableDelete = Boolean(min && array.length <= min)
  const setForm = useGroupingFormValueUpdateForm()

  const onDelete = useCallback(
    () =>
      onChange?.(
        array.filter((_item, i) => i !== index),
        { command: 'delete', item: array[index] },
      ),
    [onChange, array, index],
  )

  const handleSetAnswer = useCallback(() => {
    setForm({ form: 'answer', answerName: name, answerIndex: index })
  }, [setForm, index, name])

  return (
    <div className={s.root}>
      <div className={s.header}>
        <span className={s.title}>
          {t('elements.grouping.form.answer')} {index + 1}
        </span>
        <span className={s.actions}>
          <Tooltip overlay={t('uiKit.tooltip.delete')}>
            <IconButton
              disabled={disableDelete}
              icon='otherTrash'
              name={`${name}.delete`}
              onClick={onDelete}
              size={KitSize.XS}
              styleType='ghost'
            />
          </Tooltip>
        </span>
      </div>
      <TileButton icon='otherAdd' name={`${name}.open`} onClick={handleSetAnswer} styleType='ghost'>
        <PanelIconImage file={item.image} icon='otherBlock' />
        <Typography rows={1} styleType='hint'>
          {item.label || t('elements.grouping.tags.answer')}
        </Typography>
      </TileButton>
    </div>
  )
}

export default React.memo(GroupingFormValueItemAnswer) as typeof GroupingFormValueItemAnswer
